import { features } from "@/mocks/product";

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-[#f5f4f2] py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
            <div>
              <span className="text-xs font-medium text-stone-400 tracking-widest uppercase">
                Built to Last
              </span>
              <h2 className="mt-3 text-2xl md:text-4xl font-semibold text-stone-900">
                Every Detail, <span className="text-rose-700">Built for Your Cat</span>
              </h2>
              <p className="mt-2 text-sm md:text-base text-stone-500">
                From natural jute rope to a sturdy wood base — quality you can see and feel.
              </p>
            </div>
            <span className="hidden md:inline-flex mt-4 md:mt-0 px-4 py-2 bg-stone-900 text-white text-xs font-medium rounded-full">
              5 Core Features
            </span>
          </div>

          <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="flex-shrink-0 w-64 md:w-72 snap-start bg-white rounded-2xl overflow-hidden border border-stone-100"
              >
                <div className="relative aspect-square bg-stone-100 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="text-base font-semibold text-stone-900">
                        {feature.name}
                      </h3>
                      <p className="mt-1 text-xs text-stone-500 whitespace-pre-line leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                    <span className="text-sm font-bold text-stone-900 whitespace-nowrap ml-3 px-2 py-1 bg-stone-100 rounded-lg">
                      {feature.param}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
}